import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54f32b30&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/static/css/home/index.css?vue&type=style&index=0&id=54f32b30&prod&lang=css&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=54f32b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f32b30",
  null
  
)

export default component.exports